import { orderInformationStyles as styles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { commonHeading } from "@solveindustrial/WidgetExtensions/Components/SmallHeadingAndTextExtension";
import { css } from "styled-components";

styles.headingAndTextStyles = {
    ...styles.headingAndTextStyles,
    heading: {
        ...commonHeading,
    },
};

styles.OrderInformationGridContainer = {
    ...styles.OrderInformationGridContainer,
    gap: 0,
    css: css`
        ${styles.OrderInformationGridContainer?.css}
    `,
    offsetCss: css`
        ${styles.OrderInformationGridContainer?.offsetCss}
        width: 100%;
        margin: 0;
        display: flex;
        flex-direction: row;
        row-gap: 24px;
        flex-wrap: wrap;
    `,
};
